import { 
    KC_AUTH_LOGIN, 
    KC_AUTH_LOGOUT, 
    KC_UPDATE_TOKEN 
} from '../actions/_types';

const initialState = {
    isAuthenticated: false,
    keycloak: null,
    profile: null,
    token: null
};

export default function authReducer(state = initialState, action) {
    switch (action.type) {
        case KC_AUTH_LOGIN:
            return {
                ...state,
                isAuthenticated: true,
                keycloak: action.payload.keycloak,
                profile: action.payload.profile,
                token: action.payload.token
            };
        case KC_AUTH_LOGOUT:
            return initialState;
        case KC_UPDATE_TOKEN:
            return {
                ...state,
                keycloak: action.payload.keycloak,
                token: action.payload.token
            };
        default:
            return state;
    }
}